const countryTranslations = {
  ad: "Andorra",
  ae: "Các Tiểu Vương quốc Ả Rập Thống nhất",
  af: "Afghanistan",
  ag: "Antigua và Barbuda",
  ai: "Anguilla",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  ar: "Argentina",
  as: "Samoa thuộc Mỹ",
  at: "Áo",
  au: "Australia",
  aw: "Aruba",
  ax: "Quần đảo Åland",
  az: "Azerbaijan",
  ba: "Bosnia và Herzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Bỉ",
  bf: "Burkina Faso",
  bg: "Bulgaria",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "St. Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Ca-ri-bê Hà Lan",
  br: "Brazil",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Belarus",
  bz: "Belize",
  ca: "Canada",
  cc: "Quần đảo Cocos (Keeling)",
  cd: "Congo - Kinshasa",
  cf: "Cộng hòa Trung Phi",
  cg: "Congo - Brazzaville",
  ch: "Thụy Sĩ",
  ci: "Côte d’Ivoire",
  ck: "Quần đảo Cook",
  cl: "Chile",
  cm: "Cameroon",
  cn: "Trung Quốc",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cape Verde",
  cw: "Curaçao",
  cx: "Đảo Giáng Sinh",
  cy: "Síp",
  cz: "Séc",
  de: "Đức",
  dj: "Djibouti",
  dk: "Đan Mạch",
  dm: "Dominica",
  do: "Cộng hòa Dominica",
  dz: "Algeria",
  ec: "Ecuador",
  ee: "Estonia",
  eg: "Ai Cập",
  eh: "Tây Sahara",
  er: "Eritrea",
  es: "Tây Ban Nha",
  et: "Ethiopia",
  fi: "Phần Lan",
  fj: "Fiji",
  fk: "Quần đảo Falkland",
  fm: "Micronesia",
  fo: "Quần đảo Faroe",
  fr: "Pháp",
  ga: "Gabon",
  gb: "Vương quốc Anh",
  gd: "Grenada",
  ge: "Georgia",
  gf: "Guiana thuộc Pháp",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Greenland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Guinea Xích Đạo",
  gr: "Hy Lạp",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Hồng Kông, Trung Quốc",
  hn: "Honduras",
  hr: "Croatia",
  ht: "Haiti",
  hu: "Hungary",
  id: "Indonesia",
  ie: "Ireland",
  il: "Israel",
  im: "Đảo Man",
  in: "Ấn Độ",
  io: "Lãnh thổ Ấn Độ Dương thuộc Anh",
  iq: "Iraq",
  ir: "Iran",
  is: "Iceland",
  it: "Italy",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordan",
  jp: "Nhật Bản",
  ke: "Kenya",
  kg: "Kyrgyzstan",
  kh: "Campuchia",
  ki: "Kiribati",
  km: "Comoros",
  kn: "St. Kitts và Nevis",
  kp: "Triều Tiên",
  kr: "Hàn Quốc",
  kw: "Kuwait",
  ky: "Quần đảo Cayman",
  kz: "Kazakhstan",
  la: "Lào",
  lb: "Li-băng",
  lc: "St. Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Litva",
  lu: "Luxembourg",
  lv: "Latvia",
  ly: "Libya",
  ma: "Ma-rốc",
  mc: "Monaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "St. Martin",
  mg: "Madagascar",
  mh: "Quần đảo Marshall",
  mk: "Bắc Macedonia",
  ml: "Mali",
  mm: "Myanmar (Miến Điện)",
  mn: "Mông Cổ",
  mo: "Macao, Trung Quốc",
  mp: "Quần đảo Bắc Mariana",
  mq: "Martinique",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldives",
  mw: "Malawi",
  mx: "Mexico",
  my: "Malaysia",
  mz: "Mozambique",
  na: "Namibia",
  nc: "New Caledonia",
  ne: "Niger",
  nf: "Đảo Norfolk",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Hà Lan",
  no: "Na Uy",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "New Zealand",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Polynesia thuộc Pháp",
  pg: "Papua New Guinea",
  ph: "Philippines",
  pk: "Pakistan",
  pl: "Ba Lan",
  pm: "Saint Pierre và Miquelon",
  pr: "Puerto Rico",
  ps: "Lãnh thổ Palestine",
  pt: "Bồ Đào Nha",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Romania",
  rs: "Serbia",
  ru: "Nga",
  rw: "Rwanda",
  sa: "Ả Rập Xê-út",
  sb: "Quần đảo Solomon",
  sc: "Seychelles",
  sd: "Sudan",
  se: "Thụy Điển",
  sg: "Singapore",
  sh: "St. Helena",
  si: "Slovenia",
  sj: "Svalbard và Jan Mayen",
  sk: "Slovakia",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Suriname",
  ss: "Nam Sudan",
  st: "São Tomé và Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syria",
  sz: "Swaziland",
  tc: "Quần đảo Turks và Caicos",
  td: "Chad",
  tg: "Togo",
  th: "Thái Lan",
  tj: "Tajikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunisia",
  to: "Tonga",
  tr: "Thổ Nhĩ Kỳ",
  tt: "Trinidad và Tobago",
  tv: "Tuvalu",
  tw: "Đài Loan",
  tz: "Tanzania",
  ua: "Ukraina",
  ug: "Uganda",
  us: "Hoa Kỳ",
  uy: "Uruguay",
  uz: "Uzbekistan",
  va: "Thành Vatican",
  vc: "St. Vincent và Grenadines",
  ve: "Venezuela",
  vg: "Quần đảo Virgin thuộc Anh",
  vi: "Quần đảo Virgin thuộc Mỹ",
  vn: "Việt Nam",
  vu: "Vanuatu",
  wf: "Wallis và Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "Nam Phi",
  zm: "Zambia",
  zw: "Zimbabwe"
};
export default countryTranslations;
